import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IBaryError } from 'models/bary-error';
import { BaryProblem, IBaryProblem } from 'models/problem';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertService, AlertType } from './alert.service';

export class ErrorParser {
  private problem?: IBaryProblem;
  private alertService: AlertService;
  private baryErrorService: BaryErrorService;
  private translateService: TranslateService;
  private excludeType: string[];

  constructor(baryErrorService: BaryErrorService, alertService: AlertService, translateService: TranslateService) {
    this.alertService = alertService;
    this.baryErrorService = baryErrorService;
    this.translateService = translateService;
    this.excludeType = [];
  }

  private static isBaryProblem(errorData: any): errorData is IBaryProblem {
    return !!(errorData as IBaryProblem).type;
  }

  private static hasError(httpResponse: HttpErrorResponse): boolean {
    return !!httpResponse.error;
  }

  new(httpErrorResponse: HttpErrorResponse): ErrorParser {
    this.excludeType = [];
    if (ErrorParser.hasError(httpErrorResponse)) {
      const rawError = httpErrorResponse.error;
      if (ErrorParser.isBaryProblem(rawError)) {
        this.problem = rawError as BaryProblem;
      }
    }
    return this;
  }

  alertIf(errorType: string, messageKey: string): ErrorParser {
    this.excludeType.push(errorType);
    if (this.problem && this.problem.type === errorType) {
      this.alertService.error(messageKey);
    }
    return this;
  }

  do(): ErrorParser {
    // Global configuration
    if (this.problem) {
      if (!this.excludeType.includes(this.problem.type!)) {
        if ((this.problem.baryErrors || []).length > 0) {
          let message = this.translateService.instant('error.code.' + this.problem.errorCode);
          this.problem.baryErrors.forEach((it, index) => {
            if (index === 0) {
              message += '<ul>';
            }
            message += '<li>' + this.baryErrorService.getMessage(it) + '</li>';
            if (index === this.problem!.baryErrors.length) {
              message += '</ul>';
            }
          });

          const jhiAlert = {
            type: 'danger' as AlertType,
            msg: message,
            params: [],
            toast: true,
            position: 'top',
            scoped: undefined,
            close: undefined,
          };
          this.alertService.get().push(jhiAlert);
        } else {
          this.alertService.error('error.code.' + this.problem.errorCode);
        }
      }
    } else {
      this.alertService.error('error.validation');
    }
    return this;
  }
}

@Injectable({ providedIn: 'root' })
export class BaryErrorService {
  private parseInstance: ErrorParser;

  constructor(private translateService: TranslateService, private alertService: AlertService) {
    this.parseInstance = new ErrorParser(this, alertService, translateService);
  }

  public getMessage(baryError: IBaryError): string {
    return this.translateService.instant('error.code.' + baryError.errorCode, baryError.errorParams) as string;
  }

  public getMessageFromBaryProblem(baryProblem: IBaryProblem): string[] {
    let errors: string[] = [];
    if ((baryProblem.baryErrors || []).length > 0) {
      errors = baryProblem.baryErrors.map(error => this.getMessage(error));
    } else if (baryProblem.detail) {
      errors.push(baryProblem.detail);
    } else if (baryProblem.message) {
      errors.push(baryProblem.message);
    }
    return errors;
  }

  public baryErrorsToString(baryErrors: IBaryError[]): string[] {
    return baryErrors.map(it => this.getMessage(it));
  }

  public parser(httpErrorReponse?: HttpErrorResponse): ErrorParser | undefined {
    if (!httpErrorReponse) {
      return undefined;
    }
    this.parseInstance = this.parseInstance.new(httpErrorReponse);
    return this.parseInstance;
  }
}
